import {
    useEffectAfterMount,
    useQueryParamsExecute,
    useRouter,
} from "@relode/core";
import qs from "qs";

import { JobSearchActions } from "./jobSearchActions";
import { initialJobSearchState, SearchState } from "./jobSearchState";

export const useJobSearchHandlers = (
    state: SearchState,
    actions: JobSearchActions
) => {
    const { history, location } = useRouter();

    useQueryParamsExecute(actions.search, initialJobSearchState.searchCriteria);

    useEffectAfterMount(() => {
        const queryString = qs.stringify(state.searchCriteria, {
            skipNulls: true,
            addQueryPrefix: true,
            sort: (a, b) => a.localeCompare(b),
        });
        if (queryString === location.search) return;
        history.push({ search: queryString });
    }, [state.searchCriteria]);
};
